export const isCasting = (): boolean =>
  window.cast &&
  [
    cast.framework.CastState.CONNECTED,
    cast.framework.CastState.CONNECTING
  ].includes(window.cast.framework.CastContext.getInstance().getCastState());

const isChromeBrowser = !!window.chrome;

export const castingSupported = (): boolean =>
  isChromeBrowser && !!__CHROMECAST_RECEIVER_APPLICATION_ID;
